import { IWidget } from 'common';
import { style } from 'typestyle';

import { GridIcon } from '../../Icons/ProductCTAIcons/Grid';
import { SliderIcon } from '../../Icons/ProductCTAIcons/Slider';
import { NoneIcon } from '../../Icons/ProductCTAIcons/None';

type ThumbnailProductCTA = IWidget['settings']['thumbnail_product_cta'];

interface Props {
  thumbnail_product_cta: ThumbnailProductCTA;
  onChange: (thumbnail_product_cta: ThumbnailProductCTA) => void;
}

export function ThumbnailProductCTASelector({ thumbnail_product_cta, ...props }: Props) {
  const onChange = (thumbnail_product_cta: ThumbnailProductCTA) => {
    props.onChange(thumbnail_product_cta);
  };

  return (
    <div className={selectClass}>
      <div className={itemClass}>
        <GridIcon onClick={() => onChange('grid')} selected={thumbnail_product_cta === 'grid'} />{' '}
        GRID
      </div>
      <div className={itemClass}>
        <SliderIcon onClick={() => onChange('slider')} selected={thumbnail_product_cta === 'slider'} />{' '}
        SLIDER
      </div>
      <div className={itemClass}>
        <NoneIcon onClick={() => onChange('none')} selected={thumbnail_product_cta === 'none'} />{' '}
        NONE
      </div>
    </div>
  );
}

const selectClass = style({
  marginTop: '10px',
  marginBottom: '10px',
  display: 'flex',
  flexDirection: 'row',
});

const itemClass = style({
  fontSize: '0.7em',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: '20px',
  $nest: {
    '& svg': {
      marginRight: '5px',
    },
  },
});
